import React from 'react';
import '../styles/Features.css';

interface Feature {
  icon: string;
  title: string;
  description: string;
}

const features: Feature[] = [
  {
    icon: '\uD83D\uDDE3\uFE0F',
    title: 'Natural Conversation',
    description: 'Six far-field microphones and advanced natural language understanding let Jibo hear and understand you from across the room.',
  },
  {
    icon: '\uD83D\uDC41\uFE0F',
    title: 'Face Recognition',
    description: 'Dual high-resolution stereo cameras let Jibo recognize individual family members, greet them by name, and track their movement.',
  },
  {
    icon: '\uD83D\uDC83',
    title: 'Expressive Movement',
    description: 'Three rotating body segments with DC motors created smooth, lifelike movement. Jibo could dance, turn to face you, and strike expressive poses.',
  },
  {
    icon: '\uD83D\uDCF7',
    title: 'Photography',
    description: 'Jibo could take family photos and selfies, capturing moments at just the right time with his built-in cameras.',
  },
  {
    icon: '\uD83D\uDCDA',
    title: 'Storytelling',
    description: 'Jibo could read stories to children with animated expressions and sound effects, making bedtime reading a whole new experience.',
  },
  {
    icon: '\uD83E\uDDE0',
    title: 'Proactive Intelligence',
    description: 'Unlike passive assistants, Jibo could initiate conversations, offer reminders, and make suggestions based on your preferences.',
  },
  {
    icon: '\uD83C\uDFAE',
    title: 'Games & Learning',
    description: 'Interactive games, trivia, and a "Be a Maker" coding tool based on MIT Scratch let kids and adults learn while having fun.',
  },
  {
    icon: '\uD83C\uDFE0',
    title: 'Smart Home',
    description: 'Integration with other smart home devices let Jibo help control your connected home while providing a warm, social interface.',
  },
];

const Features: React.FC = () => {
  return (
    <section id="features" className="features">
      <div className="features__container">
        <h2 className="section-title">What Could Jibo Do?</h2>
        <p className="section-subtitle">
          A social robot with heart and smarts
        </p>

        <div className="features__grid">
          {features.map((feature, index) => (
            <div key={index} className="features__card">
              <div className="features__icon">{feature.icon}</div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
